// src/services/comisionesService.js
import api from './api';

export const comisionesService = {

  // ─── CONFIGURACIÓN ────────────────────────────────────────────────────────

  async listarConfiguraciones() {
    const res = await api.get('/comisiones/configuracion');
    return res.data;
  },

  async getConfiguracion(usuarioId) {
    const res = await api.get(`/comisiones/configuracion/${usuarioId}`);
    return res.data;
  },

  async guardarConfiguracion(usuarioId, datos) {
    const res = await api.post(`/comisiones/configuracion/${usuarioId}`, datos);
    return res.data;
  },

  // ─── CÁLCULO (legacy, aún disponible) ────────────────────────────────────

  async calcularMes(usuarioId, anio, mes) {
    const res = await api.post('/comisiones/calcular', { usuario_id: usuarioId, anio, mes });
    return res.data;
  },

  // ─── REPORTES ─────────────────────────────────────────────────────────────

  async getReportePeriodo(anio, mes) {
    const res = await api.get('/comisiones/reporte', { params: { anio, mes } });
    return res.data;
  },

  async getHistorialVendedor(usuarioId) {
    const res = await api.get(`/comisiones/vendedor/${usuarioId}`);
    return res.data;
  },

  // ─── DETALLE (facturas + rangos + desglose) ───────────────────────────────

  async getDetalle(usuarioId, anio, mes) {
    const res = await api.get('/comisiones/detalle', { params: { usuario_id: usuarioId, anio, mes } });
    return res.data;
  },

  // ─── VALIDACIÓN Y ESTADO ──────────────────────────────────────────────────

  async validar(usuarioId, anio, mes, fuentePago, cajaId, bancoId) {
    const res = await api.post('/comisiones/validar', {
      usuario_id: usuarioId,
      anio,
      mes,
      fuente_pago: fuentePago,
      caja_id:  cajaId  || null,
      banco_id: bancoId || null,
    });
    return res.data;
  },

  async cambiarEstado(comisionId, estado) {
    const res = await api.patch(`/comisiones/${comisionId}/estado`, { estado });
    return res.data;
  },

  // ─── CUENTAS (cajas y bancos) ─────────────────────────────────────────────

  async getCuentas() {
    const res = await api.get('/comisiones/cuentas');
    return res.data;
  },
};

